import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';

import { sort_candidates_by_party } from '../election-utils';

import text from '../../../data/text.json';

const converter = PreactHTMLConverter();

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  notes: { [key: string]: any };
  tableHeader: JSX.Element;
  contestTitle: string;
  contestOffice: string;
  renderCandidate: any;
  visibleCandidatesCount?: number;
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      contestTitle,
      contestOffice,
      renderCandidate,
      notes,
      tableHeader,
    } = this.props;

    let candidates = sort_candidates_by_party(contest.candidacies);

    const IsUnopposedState = candidates.length == 1 && contest.office != 'U.S. House' ? true : false;

    const IsNoted = notes && notes.length > 0 ? true : false;

    return (
      <div class="seat">
        <div class="seat__race">
          <div class="race">
            <h3 class="seat__title balance-text">
              {contestOffice != null && (
                <h2 class="office__title">{contestOffice}</h2>
              )}

              {contestTitle}
            </h3>

            <table class="race__candidates">
              {tableHeader}
              <tbody>
                {candidates.map((candidate: any, idx: any) =>
                  renderCandidate(candidate, idx)
                )}
              </tbody>
            </table>
          </div>
          {IsNoted == true && (
            <p class="note__text">
              {converter.convert(notes[0].value)}
            </p>
          )}
           {IsUnopposedState == true && (
            <p class="note__text">
             {IsNoted == false ? 'Note:' : '' } {converter.convert(text['uncontested-races'])}
            </p>
          )}
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
  visibleCandidatesCount: 3,
};

export default Contest;
